import React, { useState, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { Element, Spinner } from '@americanexpress/aqx-components';
import { getPznInfo } from 'src/universal/redux/pznData.js';
import { getPageState } from 'src/universal/redux/page';

import styles from './__styles__/index.scss?modules';

const PznAboveTheFold = ({
  pznInfo,
  spinnerHeight,
  children,
  pageState,
  hideSpinner
}) => {
  const [isSpinnerVisible, setSpinnerVisibility] = useState(true);

  const spinnerText = get(pageState, 'page.accessibility.spinnerText') || '';
  const isActiveVal = hideSpinner ? false : isSpinnerVisible;

  useLayoutEffect(
    () => {
      if (pznInfo.hasPznArrived) {
        setSpinnerVisibility(false);
      }
    },
    [pznInfo.hasPznArrived]
  );

  return (
    <React.Fragment>
      <div role="alert" tabIndex="-1">
        <Element
          className={styles.pznAboveFoldSpinner}
          style={{
            height: spinnerHeight,
            display: isSpinnerVisible ? 'block' : 'none'
          }}
        >
          <Spinner $size="large" active={isActiveVal} ariaLabel={spinnerText} />
        </Element>
      </div>
      <div aria-busy={isSpinnerVisible}>{children}</div>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  pznInfo: getPznInfo(state),
  pageState: getPageState(state)
});

export default connect(mapStateToProps)(PznAboveTheFold);
